module.exports = "../../../../platform/assets/pageMainIcon/business_jichudanganlei1.svg";